export default function RecipeVariations({ blocks = [] }) {
  if (!blocks.length) return null;

  return (
    <section className="py-8 px-6">
      <div className="max-w-4xl mx-auto space-y-6">
        {blocks.map((block, idx) => {
          if (block.type === 'heading') {
            return (
              <h2
                key={idx}
                className="text-2xl md:text-3xl font-serif font-bold text-center text-primary-red"
              >
                {block.text}
              </h2>
            );
          }
          if (block.type === 'subheading') {
            const Tag = block.level === 'h2' ? 'h2' : 'h3';
            return (
              <Tag
                key={idx}
                className={`font-serif font-bold ${
                  block.level === 'h2'
                    ? 'text-2xl text-gray-900'
                    : 'text-xl text-primary-red'
                }`}
              >
                {block.text}
              </Tag>
            );
          }
          if (block.type === 'ol') {
            return (
              <ol
                key={idx}
                className="space-y-3 list-decimal list-inside text-gray-700 leading-relaxed"
              >
                {block.items.map((item, itemIdx) => (
                  <li key={itemIdx}>{item}</li>
                ))}
              </ol>
            );
          }
          if (block.type === 'ul') {
            return (
              <ul
                key={idx}
                className="space-y-3 list-disc list-inside text-gray-700 leading-relaxed"
              >
                {block.items.map((item, itemIdx) => (
                  <li key={itemIdx}>{item}</li>
                ))}
              </ul>
            );
          }
          if (block.type === 'p') {
            return (
              <p key={idx} className="text-gray-700 leading-relaxed">
                {block.text}
              </p>
            );
          }
          if (block.type === 'divider') {
            return <hr key={idx} className="border-gray-200" />;
          }
          return null;
        })}
      </div>
    </section>
  );
}
